import { Button } from "@components/button/button-untitledui";
import {
	mapBodyTypeToLabel,
	mapEngineTypeToLabel,
	mapTransmissionTypeToLabel,
} from "@/features/vehicle/handlers";
import type { VehicleApiResponse } from "@/features/vehicle/types";

type CharacteristicsCardProps = {
	vehicle: VehicleApiResponse;
	onEditClick: () => void;
};

export const CharacteristicsCard = ({
	vehicle,
	onEditClick,
}: CharacteristicsCardProps) => (
	<div className="rounded-[20px] border border-secondary_alt border-solid bg-bg-secondary p-6">
		<div className="mb-4 flex flex-wrap items-start justify-between gap-2">
			<div className="min-w-0">
				<h3 className="font-medium text-gray-900 text-sm">
					Características gerais
				</h3>
				<p className="text-gray-600 text-xs">
					Informações gerais relacionadas ao veículo
				</p>
			</div>
			<Button color="link-color" onClick={onEditClick} size="sm">
				Editar
			</Button>
		</div>
		<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
			<div className="flex flex-col gap-1">
				<p className="font-normal text-gray-700 text-sm leading-5">Descrição</p>
				<p className="truncate font-bold text-base text-gray-900 leading-6">
					{vehicle.description || "Não informado"}
				</p>
			</div>
			<div className="flex flex-col gap-1">
				<p className="font-normal text-gray-700 text-sm leading-5">
					Ano do modelo
				</p>
				<p className="truncate font-bold text-base text-gray-900 leading-6">
					{vehicle.modelYear || "Não informado"}
				</p>
			</div>

			<div className="flex flex-col gap-1">
				<p className="font-normal text-gray-700 text-sm leading-5">
					Ano de fabricação
				</p>
				<p className="truncate font-bold text-base text-gray-900 leading-6">
					{vehicle.manufactureYear || "Não informado"}
				</p>
			</div>

			<div className="flex flex-col gap-1">
				<p className="font-normal text-gray-700 text-sm leading-5">Câmbio</p>
				<p className="truncate font-bold text-base text-gray-900 leading-6">
					{typeof vehicle.transmissionType === "number"
						? mapTransmissionTypeToLabel(vehicle.transmissionType)
						: "Não informado"}
				</p>
			</div>

			<div className="flex flex-col gap-1">
				<p className="font-normal text-gray-700 text-sm leading-5">
					Carroceria
				</p>
				<p className="truncate font-bold text-base text-gray-900 leading-6">
					{typeof vehicle.bodyType === "number"
						? mapBodyTypeToLabel(vehicle.bodyType)
						: vehicle.bodyType || "Não informado"}
				</p>
			</div>

			<div className="flex flex-col gap-1">
				<p className="font-normal text-gray-700 text-sm leading-5">
					Cor predominante
				</p>
				<p className="truncate font-bold text-base text-gray-900 leading-6">
					{vehicle.color || "Não informado"}
				</p>
			</div>

			<div className="flex flex-col gap-1">
				<p className="font-normal text-gray-700 text-sm leading-5">Motor</p>
				<p className="truncate font-bold text-base text-gray-900 leading-6">
					{typeof vehicle.engineType === "number"
						? mapEngineTypeToLabel(vehicle.engineType)
						: "Não informado"}
				</p>
			</div>

			<div className="flex flex-col gap-1">
				<p className="font-normal text-gray-700 text-sm leading-5">Renavam</p>
				<p className="truncate font-bold text-base text-gray-900 leading-6">
					{vehicle.renavam || "Não informado"}
				</p>
			</div>

			<div className="flex flex-col gap-1">
				<p className="font-normal text-gray-700 text-sm leading-5">Grupo</p>
				<p className="truncate font-bold text-base text-gray-900 leading-6">
					{vehicle.group?.name || "Não informado"}
				</p>
			</div>
		</div>
	</div>
);
